const escapeRegExp = string => string.replace(/[^a-zA-Z0-9]/g, "\\$&");

export { escapeRegExp as default };
